import { useMutation } from "@tanstack/react-query";
import { deactivateMetaIntegration } from "../../api/bMetaApi";

export const useDeactivateMeta = () => {
  return useMutation({
    mutationKey: ["deactivate-meta"],
    mutationFn: (data) => deactivateMetaIntegration(data),
    onError: (error) => {
      console.error("Meta deactivation error:", error.response || error);
    },
  });
};
